var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.453 21a4.47 4.47 0 01-2.59-.846 36.927 36.927 0 01-4.867-4.229 37.27 37.27 0 01-4.144-4.97c-1.553-2.114-.932-4.862 1.45-7.4.725-.74 1.968-.74 2.694 0l1.45 1.48c.31.317.518.846.518 1.375 0 .528-.208 1.057-.518 1.374l-.622.635c-.207.211-.103.528 0 .74.725.951 1.968 2.326 2.693 2.96.725.74 1.968 2.009 2.9 2.749a.494.494 0 00.726 0l.621-.635c.725-.74 1.968-.74 2.693 0l1.45 1.48c.311.318.518.847.518 1.375 0 .529-.207 1.057-.518 1.375-1.346 1.691-2.9 2.537-4.454 2.537zM6.65 4.084c-.207 0-.414.105-.622.211C3.956 6.41 3.542 8.63 4.681 10.322a35.74 35.74 0 004.04 4.863 35.404 35.404 0 004.764 4.123c1.658 1.163 3.833.74 5.905-1.374.207-.212.207-.423.207-.634 0-.212-.104-.423-.207-.635l-1.554-1.48c-.31-.317-.932-.317-1.243 0l-.622.634c-.518.529-1.346.529-2.071 0-1.036-.74-2.28-2.114-3.004-2.854-.725-.74-2.072-2.115-2.797-3.066-.518-.74-.518-1.586 0-2.115l.622-.634c.207-.212.207-.423.207-.635 0-.211-.104-.422-.207-.634l-1.45-1.48c-.208-.212-.415-.317-.622-.317z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2a54d81c0264ac0e8b33d6a2e0a77314.svg";
export { ForwardRef as ReactComponent };